var exports = {
  "kL": "container__y-ChsS",
  "Kk": "icon__XnIzMp",
  "$e": "mainText__QOMTZy",
  "Yg": "secondaryText__ickQUW",
};

module.exports = exports;
